import { AuthLayout } from 'components/Global/AuthLayout';
import GlobalLayout from 'layouts/Global';
import { ForgotPassword, Login, ResetPassword } from 'pages';
import AccessDeniedPage from 'pages/AccessDeniedPage';
import { Devices } from 'pages/Devices';
import PageNotFoundPage from 'pages/PageNotFound';
import { Companies } from 'pages/Settings/Company';
import { Roles } from 'pages/Settings/Roles';
import Settings from 'pages/Settings/Settings';
import { Users } from 'pages/Settings/Users';
import { Subscription } from 'pages/Subscription';


import { createBrowserRouter } from 'react-router-dom';

const router = createBrowserRouter([
	{
		element: <AuthLayout />,
		children: [
			{
				path: '/',
				element: <GlobalLayout />,
				children: [
					// {
					// 	index: true,
					// 	element: <Dashboard />
					// },
					{
						index: true,
						path: '/',
						element: <Devices />,
					},
					{
						path: '/subscription',
						element: <Subscription />,
					},
				],
			},
			{
				path: '/settings',
				element: <Settings />,
				children: [
					{
						index: true,
						path: 'users',
						element: <Users />,
					},
					{
						path: 'roles',
						element: <Roles />,
					},
					{
						path: 'company',
						element: <Companies/>,
					},
				]
			},
			{
				element: <Login />,
				path: '/login',
			},
			{
				path: '/reset-password',
				element: <ResetPassword />,
			},
			{
				path: '/set-password',
				element: <ResetPassword />,
			},
			{
				path: '/forgot-password',
				element: <ForgotPassword />,
			},
			{
				path: '/access-denied',
				element: <AccessDeniedPage />,
			},
		],
	},
	{
		path: '*',
		element: <PageNotFoundPage />,
	},
]);

export default router;
